import React from 'react';
import { StyleSheet, View } from 'react-native';

import { getCloudinaryUrl, Image, PRODUCT_CARD_IMAGE_CONFIG } from '@garnish/media';

import { GenericImage } from './assets';

// ─────────────────────────────────────────────────────────────────────────────

export const CustomizationFooterImage = (props: Props) => {
  const { url, alt } = props;

  const formattedUrl = url ? getCloudinaryUrl(url, PRODUCT_CARD_IMAGE_CONFIG) : GenericImage;

  return (
    <View style={styles.container}>
      <Image
        source={formattedUrl}
        style={styles.image}
        contentFit="contain"
        alt={alt}
        pointerEvents="none"
      />
    </View>
  );
};

// ─── Constants ───────────────────────────────────────────────────────────────

const IMAGE_SIZE = 196;

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    width: IMAGE_SIZE * 0.55,
  },
  image: {
    position: 'absolute',
    left: -IMAGE_SIZE * 0.2,
    bottom: -IMAGE_SIZE * 0.3,
    width: IMAGE_SIZE,
    height: IMAGE_SIZE,
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = {
  url: string | undefined;
  alt: string | undefined;
};
